// SyntraMfgLogisticsHub.jsx
import React, { useState } from "react";

export default function SyntraMfgLogisticsHub() {
  const [activeTab, setActiveTab] = useState("fleet");
  const [searchQuery, setSearchQuery] = useState("");
  const [showSearchResults, setShowSearchResults] = useState(false);

  // Dummy Data
  const fleetData = [
    { id: 1, name: "Truck - Small", capacity: "2 Ton", status: "Available" },
    { id: 2, name: "Truck - Medium", capacity: "5 Ton", status: "In Transit" },
    { id: 3, name: "Van - Refrigerated", capacity: "1 Ton", status: "Available" },
  ];

   const transportData = [
    { id: 1, route: "Mumbai → Delhi", distance: "1400 km", mode: "Truck" },
    { id: 2, route: "Delhi → Bangalore", distance: "2000 km", mode: "Train" },
    { id: 3, route: "Mumbai → Pune", distance: "150 km", mode: "Van" },
  ];

  const calculatorsData = [
    { id: 1, name: "Freight Cost Estimator", formula: "Distance × Rate per KM" },
    { id: 2, name: "Inventory Turnover Calculator", formula: "COGS / Average Inventory" },
    { id: 3, name: "Carbon Footprint Estimator", formula: "Fuel × Emission Factor" },
  ];

 
  const handleSearch = () => {
    setShowSearchResults(true);
  };

  return (
    <div className="min-h-screen bg-cyan-500 p-4">
      <h1 className="text-3xl font-bold text-center bg-cyan-700 text-white mb-6 rounded-xl px-4 py-4">
        🚚 SyntraMfg Logistics Hub
      </h1>

      {/* Search Panel */}
      <div className="flex flex-col sm:flex-row justify-center gap-2 mb-4 px-4 py-2 rounded-lg bg-cyan-700">
        <input
          type="text"
          placeholder="Search fleet, warehouses, transport, or topics..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="rounded-lg w-full sm:w-2/3 h-10 px-2"
        />
        <button
          onClick={handleSearch}
          className="w-full sm:w-24 h-10 bg-purple-700 hover:bg-purple-800 text-white rounded-lg"
        >
          🔍
        </button>
      </div>

      {showSearchResults && (
        <div className="bg-white rounded-lg p-4 mb-6 max-w-5xl mx-auto">
          <h2 className="text-blue-600 font-bold text-lg mb-2">Search Results for "{searchQuery}"</h2>
          <ul className="list-disc pl-5 space-y-1">
            <li>Example Fleet / Vehicle 1</li>
            <li>Example Transport Route 1</li>
            <li>Example Calculator / Tool 1</li>
          </ul>
        </div>
      )}

      {/* Tabs */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-2 mb-4 justify-items-center">
        {[
          { id: "fleet", label: "Fleet" },
          { id: "transport", label: "Transport" },
          { id: "calculators", label: "Calculators" },
        ].map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-4 py-2 rounded-lg font-semibold w-full transition-colors duration-200
              ${activeTab === tab.id ? "bg-purple-700 text-white" : "bg-white text-black hover:bg-gray-200"}`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="max-w-6xl mx-auto bg-white rounded-lg p-4 shadow-lg">
        {activeTab === "fleet" && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {fleetData.map((v) => (
              <div key={v.id} className="bg-cyan-600 p-4 rounded-lg shadow hover:shadow-lg transition">
                <h3 className="font-bold mb-2">{v.name}</h3>
                <p>Capacity: {v.capacity}</p>
                <p>Status: {v.status}</p>
                <button className="mt-2 bg-purple-600 hover:bg-purple-700 text-white px-3 py-1 rounded-lg">
                  Details
                </button>
              </div>
            ))}
          </div>
        )}

        {activeTab === "transport" && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {transportData.map((t) => (
              <div key={t.id} className="bg-cyan-600 p-4 rounded-lg shadow">
                <h3 className="font-bold mb-2">{t.route}</h3>
                <p>Distance: {t.distance}</p>
                <p>Mode: {t.mode}</p>
              </div>
            ))}
          </div>
        )}

        {activeTab === "calculators" && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {calculatorsData.map((calc) => (
              <div key={calc.id} className="bg-cyan-600 p-4 rounded-lg shadow">
                <h3 className="font-bold mb-2">{calc.name}</h3>
                <p className="text-sm">{calc.formula}</p>
                <button className="mt-2 bg-purple-600 hover:bg-purple-700 text-white px-3 py-1 rounded-lg">
                  Open Calculator
                </button>
              </div>
            ))}
          </div>
        )}

       
      </div>
    </div>
  );
}
